export default __webpack_public_path__ + "static/media/risk-level-3.e4d918e8.svg";